// store/userGenerationSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GenerateUser } from '../types';

interface UserGenerationState {
  excelData: any[][] | null;
  status: string;
  fileUploaded: boolean;
  fileProcessed: boolean;
    selectedRows: string[];
    filter: string;
    columnFilters: { [key: string]: string };
    sortConfig: { key: keyof GenerateUser; direction: 'ascending' | 'descending' } | null;
    filterDropdown: string | null; // Add filterDropdown to state
}

const initialState: UserGenerationState = {
  excelData: null,
  status: 'Please select a file.',
  fileUploaded: false,
  fileProcessed: false,
  selectedRows: [],
  filter: '',
  columnFilters: {},
  sortConfig: null,
  filterDropdown: null, // Initialize filterDropdown

};

const userGenerationSlice = createSlice({
  name: 'userGeneration',
  initialState,
  reducers: {
    setExcelData(state, action: PayloadAction<any[][] | null>) {
      state.excelData = action.payload;
    },
    setStatus(state, action: PayloadAction<string>) {
      state.status = action.payload;
    },
    setFileUploaded(state, action: PayloadAction<boolean>) {
      state.fileUploaded = action.payload;
    },
    setFileProcessed(state, action: PayloadAction<boolean>) {
      state.fileProcessed = action.payload;
    },
    resetState(state) {
      state.excelData = null;
      state.status = 'Please select a file.';
      state.fileUploaded = false;
      state.fileProcessed = false;
    },
    toggleRowSelection(state, action: PayloadAction<string>) {
          const loginID = action.payload;
          if (state.selectedRows.includes(loginID)) {
            state.selectedRows = state.selectedRows.filter(id => id !== loginID);
          } else {
            state.selectedRows.push(loginID);
          }
        },
        setFilter(state, action: PayloadAction<string>) {
          state.filter = action.payload;
        },
        clearSelection(state) {
          state.selectedRows = [];
        },
        selectAllRows(state, action: PayloadAction<string[]>) {
          state.selectedRows = action.payload;
        },
        setColumnFilter(state, action: PayloadAction<{ key: keyof GenerateUser; value: string }>) {
          const { key, value } = action.payload;
          state.columnFilters[key] = value;
        },
        setSortConfig(state, action: PayloadAction<{ key: keyof GenerateUser; direction: 'ascending' | 'descending' } | null>) {
          state.sortConfig = action.payload;
        },
        setFilterDropdown(state, action: PayloadAction<string | null>) {
          state.filterDropdown = action.payload; // Add reducer for filterDropdown
        },
  },
});

export const {
  setExcelData,
  setStatus,
  setFileUploaded,
  setFileProcessed,
  resetState,
  toggleRowSelection,
  setFilter,
  clearSelection,
  selectAllRows,
  setColumnFilter,
  setSortConfig,
  setFilterDropdown,
} = userGenerationSlice.actions;

export default userGenerationSlice.reducer;
